import React from 'react'
import Fade from 'react-reveal/Fade'

import BrandCard from './cards/brand'

const BrandsArchive = ({ title = '', content = '', brands = [] }) => {

  return (
    <>
      <section className='category-archive category-archive--brands'>
        <div className='category-archive__inner'>
          <Fade bottom distance={'40px'}>
            <div className='category-archive__header'>
              { title && <h2 dangerouslySetInnerHTML={{ __html: title }} /> }
              { content && <div className='category-archive__header-content' dangerouslySetInnerHTML={{ __html: content }} /> }
            </div>
            <div className='category-archive__list'>
              { brands?.map((el) => (<BrandCard key={el.id} {...el} />)) }
            </div>
          </Fade>
        </div>
      </section>
    </>
  )
}

export default BrandsArchive